export default __webpack_public_path__ + "static/media/34.879eb1d4.jpg";